/*@flow*/
import * as t from 'lib/t';
import EmptyArray from 'lib/EmptyArray';
import EmptyObject from 'lib/EmptyObject';

export default t.subtype(
  t.Any,
  (x: any) => {
    if (t.Array.is(x)) {
      return !EmptyArray.is(x);
    } else if (t.Object.is(x)) {
      return !EmptyObject.is(x);
    }
    return Boolean(x);
  },
  'Present'
);
